import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useB2cClose = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [closeList, setCloseList] = useState<B2cListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.b2c.list.close, location.search],
    () =>
      fetcher.b2c.postProjectCloseList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
        pm: searchParams.pm ? String(searchParams.pm) : '', 
        company: searchParams.company ? String(searchParams.company) : '',   
        crm: searchParams.crm ? String(searchParams.crm) : '',
        lecture_subject: searchParams.lecture_subject ? String(searchParams.lecture_subject) : '',  
        group_id: searchParams.group_id ? Number(searchParams.group_id) : null,  
      }),
    {
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setCloseList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { closeList, searchResult, refetch };
};

export default useB2cClose;
